import { Box, FlexContainer } from '@bos/ui';
import type { ReactNode } from 'react';

import { AppHorizontalDivider } from './AppHorizontalDivider';
import { AppInfoTooltip } from './AppInfoTooltip';
import type { AppRadioItemProps } from './AppRadioItem/AppRadioItem';
import { AppRadioItem } from './AppRadioItem/AppRadioItem';
import { AppText } from './AppText/AppText';

export type AppRadioListItemProps = Omit<
	AppRadioItemProps,
	'underLabel' | 'underRadio' | 'labelElement'
> & { divider?: ReactNode; tooltip?: string };

export const AppRadioListItem = ({
	divider = <AppHorizontalDivider />,
	label,
	tooltip,
	...rest
}: AppRadioListItemProps) => {
	return (
		<AppRadioItem
			{...rest}
			labelElement={
				<FlexContainer gap>
					<AppText variant={'s1'}>{label}</AppText>
					{tooltip && <AppInfoTooltip text={tooltip} />}
				</FlexContainer>
			}
			underLabel={divider && <Box spacingTop>{divider}</Box>}
		/>
	);
};
